export const blog = process.env.GATSBY_DEFAULT_BLOG_URL;
export const docs = process.env.GATSBY_DEFAULT_DOC_URL;
export const main = process.env.GATSBY_DEFAULT_MAIN_URL;
export const app = process.env.GATSBY_DEFAULT_APP_URL || 'https://app.k6.io';
// associated microservice for this url: https://github.com/grafana/sls-k6.io-form
export const contactFormUrl = process.env.GATSBY_AWS_LAMBDA_CONTACT_FORM_URL;
